export const fathersFamilyDiscountProductAmount = 2;
export const fathersFamilyDiscountPercentage = 10;
